import React from 'react';
import { View, Text, StyleSheet, SafeAreaView, ScrollView, TouchableOpacity, Switch, Alert, Linking, Platform, Image, Modal, TextInput, ActivityIndicator } from 'react-native';
import { httpsCallable } from 'firebase/functions';
import { Ionicons } from '@expo/vector-icons';
import { useAppStore } from '../../store/useAppStore';
// La tabla que decide donde aterriza cada rol. Se importa en vez de repetir
// los destinos aqui: duplicarla es como esta tarjeta se quedo vieja y acabo
// mandando a un duenno de negocio al KYC de chofer.
import {
  rutaSegunRol,
  verificacionAplazadaEnEstaSesion,
  aplazarVerificacionEnEstaSesion,
} from '../_layout';
import { callCambiarMiModo } from '../../services/cloudFunctions';
import { useThemeColors } from '../../constants/theme';
import { PLATFORM_CARD_ENABLED, VERTICAL_ESCOLAR_VISIBLE, VERTICAL_LOGISTICA_VISIBLE } from '../../constants/featureFlags';
import { whatsappSoporte, SOPORTE_TELEFONO, SOPORTE_CORREO } from '../../constants/contacto';
import ScreenBackground from '../../components/ScreenBackground';
import AvisoVistaPrevia from '../../components/AvisoVistaPrevia';
import BarraDeNivel from '../../components/BarraDeNivel';
import TarjetaMiVehiculo from '../../components/TarjetaMiVehiculo';
import { esInvitado, bloquearSiInvitado, salirDelModoInvitado } from '../../services/modoInvitado';
import { useRouter, useFocusEffect } from 'expo-router';
import { SIZES } from '../../constants/theme';
import WalletModal from '../../components/WalletModal';
import RewardsModal from '../../components/RewardsModal';
import { authBridge, prepararCambioDeModo } from '../../services/authBridge';
import { firestoreService } from '../../services/firestoreService';
import { locationService } from '../../services/locationService';
import { rideSessionStore } from '../../services/rideSessionStore';
import { useVehiculoDelChofer } from '../../hooks/useVehiculoDelChofer';
import { functions as webFunctions } from '../../services/firebaseConfig';
import { mensajeDeError } from '../../utils/mensajeDeError';
import { llamarBorradoDeCuenta, FRASE_BORRADO } from '../../services/borrarCuenta';
import { pesos } from '../../utils/dinero';

// El borrado vive ahora en services/borrarCuenta.ts: hacía falta también desde
// `verify-email.tsx`, y duplicar una llamada que BORRA DATOS es pedir que una
// de las dos copias se quede con el tiempo de espera viejo. La nota larga de
// por qué hizo falta compartirlo está en ese archivo.

export default function ProfileScreen() {
  // ⚠️ CON EL HOOK, NO CON `getState()`.
  // El interruptor viejo de QA leía `useAppStore.getState().qaMockRide` dentro
  // del propio render. Eso devuelve el valor pero NO suscribe: al cambiarlo, la
  // tarjeta no se repinta hasta que algo más provoque un render. En un panel de
  // pruebas se toleraba; en una tarjeta que usa cualquiera se lee como un botón
  // que no responde al tocarlo.
  const enDemostracion = useAppStore((state) => state.qaMockRide);
  const role = useAppStore((state) => state.userRole);
  const theme = useAppStore((state) => state.theme);
  const setTheme = useAppStore((state) => state.setTheme);
  const storeName = useAppStore((state) => state.userName);
  const storePhone = useAppStore((state) => state.userPhone);

  // ══════════════════════════════════════════════════════════════════════════
  // EL NOMBRE APROBADO, SIN TENER QUE CERRAR LA APP
  // ══════════════════════════════════════════════════════════════════════════
  // El rescate del nombre vive en `_layout.tsx` y solo corre en el ARRANQUE EN
  // FRÍO. O sea que, tras aprobar a alguien en el panel, esa persona tenía que
  // cerrar la app del todo para ver su nombre — y nadie hace eso: lo que hace
  // es volver a mirar el perfil y pensar que sigue roto.
  //
  // Esta pantalla es justo donde se mira. Una lectura al entrar, y solo se
  // escribe en el store si de verdad cambió: así no se repinta por gusto ni se
  // pisa una edición que la persona acabe de hacer en «editar perfil».
  useFocusEffect(
    React.useCallback(() => {
      const uid = useAppStore.getState().userFirebaseUid;
      if (!uid) return;
      let vivo = true;
      (async () => {
        try {
          const perfil: any = await firestoreService.getUserProfile(uid);
          if (!vivo || !perfil) return;
          const legal = String(perfil.name ?? perfil.displayName ?? '').trim();
          const ahora = useAppStore.getState();
          const actual = String(ahora.userName ?? '').trim();
          // `nombreVerificado` lo pone el servidor al aprobar: cuando está, el
          // nombre del documento manda sobre el apodo con el que se registró.
          const mandaElDocumento = perfil.nombreVerificado === true;
          if (legal && legal !== actual && (mandaElDocumento || !actual)) {
            ahora.setProfile(legal, ahora.userPhone || '', ahora.userEmail || '');
          }
        } catch (e: any) {
          console.warn('[perfil] no se pudo refrescar el nombre:', e?.message);
        }
      })();
      return () => { vivo = false; };
    }, [])
  );
  const userPhoto = useAppStore((state) => state.userPhoto);
  const isVerified = useAppStore((state) => state.isVerified);
  const colors = useThemeColors();
  const router = useRouter();

  // Datos para el recordatorio del Papel de Buena Conducta — solo aplica
  // a motoconchos/repartidores (motor) que ya pasaron por la verificación
  // inicial. Trial 30 días → al llegar a 5 o menos, recordatorio visible.
  const driverTrialDaysLeft = useAppStore((s) => s.driverTrialDaysLeft);
  const userFirebaseUid = useAppStore((s) => s.userFirebaseUid);
  // El vehiculo real, para que el bono que se PROMETE sea el que se PAGA.
  const vehiculoDelChofer = useVehiculoDelChofer();
  const vehicleTypeRaw = useAppStore((s: any) => s.vehicleType);
  const isMotorDriver = role === 'DRIVER' || role === 'DELIVERY_DRIVER';

  // FIX BANNER PRUEBA 15D — `driverTrialDaysLeft` en el store estaba hardcodeado
  // en 14 y NADIE lo sincronizaba desde Firestore, así que este banner (y el
  // recordatorio del Papel de Buena Conducta) NUNCA aparecía. Ahora escuchamos
  // el doc real del chofer y calculamos los días desde `driverTrialEndsAt`,
  // dejando el valor en el store para que RewardsModal también lo vea correcto.
  const [driverTrialStatus, setDriverTrialStatus] = React.useState<string | null>(null);
  const [driverBlockedNoPayment, setDriverBlockedNoPayment] = React.useState(false);
  React.useEffect(() => {
    if (!isMotorDriver || !userFirebaseUid) return;
    const unsub = firestoreService.listenToDriverTrial(userFirebaseUid, (info) => {
      setDriverTrialStatus(info.driverStatus);
      setDriverBlockedNoPayment(info.blockedNoPayment);
      if (typeof info.daysLeft === 'number') {
        useAppStore.setState({ driverTrialDaysLeft: info.daysLeft });
      }
    });
    return () => { try { (unsub as any)?.(); } catch {} };
  }, [isMotorDriver, userFirebaseUid]);

  // Mostrar el recordatorio cuando: (a) está en TRIAL y le quedan ≤5 días, o
  // (b) el trial venció y quedó bloqueado por falta de pago. Antes se disparaba
  // con `driverTrialDaysLeft === 0` sobre un valor que jamás cambiaba.
  const trialExpiredBlocked = driverTrialStatus === 'ACTIVE' && driverBlockedNoPayment;
  const trialEndingSoon =
    driverTrialStatus === 'TRIAL' &&
    typeof driverTrialDaysLeft === 'number' &&
    driverTrialDaysLeft <= 5 &&
    driverTrialDaysLeft >= 0;
  const showConductReminder = isMotorDriver && (trialEndingSoon || trialExpiredBlocked);

  // NOTA DE SEGURIDAD — Aquí NO va ningún acceso de administrador. La consola
  // de admin vive FUERA de la app (público /admin, ver public/admin/index.html)
  // para que su código, sus pantallas y sus llamadas NO viajen dentro del APK
  // que instala cualquier usuario.

  const [walletVisible, setWalletVisible] = React.useState(false);
  const [rewardsVisible, setRewardsVisible] = React.useState(false);

  // Anti doble toque: salir y cambiar de modo ahora esperan a la red (con tope),
  // y un segundo toque en ese rato repetía todo el proceso encima del primero.
  const saliendoRef = React.useRef(false);
  // El ref solo impedía la doble pulsación: NO repinta, así que el botón se
  // quedaba idéntico mientras `authBridge.signOut()` apagaba al chofer, borraba
  // el token de push y cerraba la sesión nativa. Con red dominicana mala eso
  // son decenas de segundos de app aparentemente colgada, y el usuario vuelve a
  // tocar creyendo que no funcionó. El estado existe solo para dar señal.
  const [saliendo, setSaliendo] = React.useState(false);
  const cambiandoModoRef = React.useRef(false);

  /**
   * CAMBIO DE MODO SEGURO — H09 / H10, auditoría 16-sep-2026.
   *
   * Las tarjetas de "Modo de usuario" cambiaban el rol y ya. Un chofer en línea
   * que tocaba "Cambiar a Pasajero" quedaba como chofer fantasma: el GPS seguía
   * publicando y /drivers/{uid} seguía en línea, sin ningún botón para
   * apagarlo (ese botón solo se dibuja con rol de chofer).
   *
   * `prepararCambioDeModo` NO deja cambiar a un chofer en línea ni a quien tiene
   * un viaje vivo que el cambio rompería, y le dice qué hacer (ver por qué no
   * se le apaga por detrás en authBridge.ts). Si puede cambiar, limpia lo que
   * haya quedado suelto. Lo que hace cada tarjeta después no cambia.
   */
  /**
   * Los roles que NO son de transporte: viven de publicar y vender, no de
   * mover gente. Las tarjetas de chofer y de pasajero no les tocan.
   *
   * `RENT_CAR_OWNER` entra aquí aunque alquile carros: él no conduce, gestiona
   * una flota. El que conduce es el chofer al que se la alquila.
   */
  const esNegocio =
    role === 'RESTAURANT_OWNER' || role === 'RENT_CAR_OWNER' || role === 'CAR_RENTER';

  /** Los roles que tienen panel propio, para saber a dónde devolver a cada uno. */
  const CON_PANEL_PROPIO = ['RENT_CAR_OWNER', 'SCHOOL_DIRECTOR', 'RESTAURANT_OWNER'];

  /**
   * Los dos únicos destinos en los que un «no» del servidor NO frena: el
   * «no» de ellos es «te faltan los papeles», y el cambio local es justo lo
   * que abre el camino para conseguirlos.
   */
  const CAMINO_AL_KYC = ['DRIVER', 'DELIVERY_DRIVER'];

  /** Los roles que no se suben a un carro: el rango por viajes no les toca. */
  const SIN_RANGO_DE_VIAJES: string[] = ['RESTAURANT_OWNER', 'RENT_CAR_OWNER', 'SCHOOL_DIRECTOR'];

  const cambiarDeModo = async (rolDestino: string, hacerCambio: () => void) => {
    if (cambiandoModoRef.current) return;
    cambiandoModoRef.current = true;
    try {
      const resultado = await prepararCambioDeModo(
        useAppStore.getState().userFirebaseUid,
        rolDestino
      );
      if (!resultado.ok) {
        if (Platform.OS === 'web') {
          // `Alert.alert` no pinta nada en web.
          window.alert(`${resultado.titulo}\n\n${resultado.mensaje}`);
        } else {
          Alert.alert(resultado.titulo, resultado.mensaje);
        }
        return;
      }

      // ══════════════════════════════════════════════════════════════════
      // Y QUE EL CAMBIO SE QUEDE HECHO
      // ══════════════════════════════════════════════════════════════════
      //
      // Hasta hoy esto solo hacía `hacerCambio()`, que por dentro es
      // `store.setRole(...)`: memoria del teléfono. El rol de verdad vive en
      // `/users/{uid}.role`, las reglas prohíben al cliente cambiarlo, y al
      // arrancar en frío `_layout.tsx` lee el de Firestore —que manda— y
      // devuelve a la persona al modo anterior. O sea que el botón funcionaba
      // hasta que cerrabas la app.
      //
      // `cambiarMiModo` es la Cloud Function que las propias reglas piden
      // («que sea una Cloud Function que revalide el KYC — no esta regla»).
      // Comprueba en el servidor que la persona tiene derecho a ese modo:
      // pasajero y cliente de comida siempre, chofer solo si tiene los papeles
      // aprobados, y dueño de negocio solo si su negocio existe de verdad.
      //
      // ⚠️ EL ORDEN IMPORTA, Y EL FALLO NO FRENA NADA. Se intenta persistir
      // ANTES de cambiar en pantalla, pero si no se puede —sin señal, o un
      // chofer que todavía no está verificado y va camino del KYC— se sigue
      // igual con el cambio local, que es exactamente lo que pasaba antes.
      // Así esto solo puede mejorar: lo que ya funcionaba sigue, y lo que no
      // se guardaba, ahora se guarda.
      //
      // ⚠ Y CUANDO EL SERVIDOR DICE QUE NO, SE PARA. PERO NO SIEMPRE.
      //
      // Hasta ahora el motivo que el servidor se tomaba el trabajo de redactar
      // moría en un `console.warn` y el cambio se hacía igual. Eso produjo una
      // puerta de un solo sentido de verdad: el dueño de un Rent Car se pasaba
      // a pasajero, y al tocar «Volver a Rent Car» el servidor lo negaba, la
      // app cambiaba en pantalla de todas formas, y al siguiente arranque
      // volvía a ser pasajero. Sin panel, sin flota y sin que nadie le dijera
      // por qué.
      //
      // El freno es SELECTIVO a propósito, y esto importa: hay un «no» que es
      // CORRECTO y tiene que dejar pasar — el del chofer que todavía no tiene
      // los papeles aprobados. A ese el cambio local es justo lo que le abre
      // el camino al KYC; frenarlo lo dejaría sin poder verificarse nunca.
      //
      // Así que la lista de los que PASAN es cerrada y corta: chofer y
      // repartidor. En esos dos el «no» del servidor significa «todavía no
      // tienes los papeles», y el cambio local es el camino al KYC. En todos
      // los demás el «no» significa «eso no es tuyo», y seguir solo sirve para
      // enseñar una pantalla que al reiniciar desaparece.
      //
      // OJO si se añade un destino nuevo: por defecto FRENA. Es el lado bueno
      // para equivocarse — un freno de más se ve y se reporta; un cambio que
      // se deshace solo al reiniciar no, y es lo que nos tuvo un mes con un
      // botón cosmético.
      let frenadoPorElServidor = false;
      try {
        const r = await callCambiarMiModo({ destino: rolDestino });
        if (r?.data?.persistido === false) {
          const motivoServidor = String(r.data.motivo ?? '').trim();
          console.warn('[profile] el modo no se persistió:', motivoServidor);
          const esCaminoAlKyc = CAMINO_AL_KYC.includes(rolDestino);
          if (!esCaminoAlKyc && motivoServidor) {
            frenadoPorElServidor = true;
            const titulo = 'No pudimos cambiarte de modo';
            if (Platform.OS === 'web') window.alert(`${titulo}

${motivoServidor}`);
            else Alert.alert(titulo, motivoServidor);
          }
        }
      } catch (e: any) {
        // Un fallo de RED no frena nada: se sigue con el cambio local, que es
        // lo que pasaba antes de que esta llamada existiera.
        console.warn('[profile] no se pudo persistir el modo:', e?.message ?? e);
      }
      if (frenadoPorElServidor) return;

      hacerCambio();
    } catch (e: any) {
      // `prepararCambioDeModo` no debería lanzar; si pasa, no se cambia a
      // ciegas con un chofer que quizá sigue en línea.
      console.warn('[profile] preparar el cambio de modo falló:', e?.message ?? e);
      const titulo = 'No pudimos cambiar de modo';
      const mensaje = 'Inténtalo otra vez en unos segundos.';
      if (Platform.OS === 'web') window.alert(`${titulo}\n\n${mensaje}`);
      else Alert.alert(titulo, mensaje);
    } finally {
      cambiandoModoRef.current = false;
    }
  };

  const handleLogout = () => {
    // MODO VISTA PREVIA — no hay sesión que cerrar. Si dejamos correr el flujo
    // normal, authBridge.signOut() no hace nada, el diálogo dice "cerrar
    // sesión" sin que exista una, y el rol se limpia dejando al invitado en
    // una app sin rol. Aquí lo sacamos limpio del modo invitado y punto.
    if (esInvitado()) {
      salirDelModoInvitado();
      router.replace('/');
      return;
    }

    // FIX PROFESIONALISMO — Antes solo seteaba isLoggedIn=false en el store
    // y navegaba a '/'. PERO Firebase Auth seguía con sesión activa: al
    // reabrir la app el observer en _layout detectaba el currentUser y
    // re-llenaba userFirebaseUid silenciosamente, dando la sensación de
    // que "el logout no funciona". Ahora cerramos Firebase + REST + store
    // antes de navegar.
    const performLogout = async () => {
      if (saliendoRef.current) return;
      saliendoRef.current = true;
      setSaliendo(true);
      try {
        // Todo el cierre vive en `authBridge.signOut()` (H01, auditoría
        // 16-sep-2026): apaga al chofer si estaba en línea (GPS + presencia),
        // borra el token de push, la notificación fija y el viaje guardado,
        // vacía la caché REST y el store en disco y cierra la sesión nativa.
        // Antes cada botón de "Salir" hacía su propio pedazo y ninguno los
        // hacía todos. (El código de referido ya no se cachea: nada que olvidar.)
        try {
          await authBridge.signOut();
        } catch (e) {
          console.warn('[profile] authBridge.signOut falló:', e);
        }
        // `resetSession()` incondicional: el store está PERSISTIDO en disco
        // (`go-safely-storage-v2`) y signOut ya lo llama, pero si algo
        // reventara antes, nombre, teléfono, correo, foto y placa se quedarían
        // en el teléfono para el siguiente. Repetirlo es gratis.
        useAppStore.getState().resetSession();
        router.replace('/');
      } finally {
        saliendoRef.current = false;
        setSaliendo(false);
      }
    };

    if (Platform.OS === 'web') {
      const confirmLogout = window.confirm('¿Estás seguro que deseas salir?');
      if (confirmLogout) performLogout();
    } else {
      Alert.alert('Cerrar Sesión', '¿Estás seguro que deseas salir?', [
        { text: 'Cancelar', style: 'cancel' },
        { text: 'Salir', style: 'destructive', onPress: performLogout },
      ]);
    }
  };

  // ═══════════════════════════════════════════════════════════════════════
  // NOTIFICACIONES — el interruptor falso se cambió por el control REAL
  // ═══════════════════════════════════════════════════════════════════════
  //
  // AQUÍ HABÍA UN <Switch> QUE NO HACÍA NADA. Era un `React.useState(true)`
  // suelto: no se guardaba en ningún sitio, no borraba el token de push, no
  // apagaba ni un solo envío del servidor, y volvía solo a "encendido" cada vez
  // que se cerraba la app. Un control muerto que además aparenta gobernar datos
  // personales es justo el rechazo vc13 de Google ("botones que no responden").
  //
  // POR QUÉ NO SE CABLEÓ EN VEZ DE QUITARLO. Guardar una bandera en
  // /users/{uid} y borrar el token con `notificationService.clearPushToken`
  // apagaría los avisos… hasta el siguiente arranque: `_layout.tsx` llama a
  // `registerForPushNotifications(uid)` en cada inicio de sesión y vuelve a
  // escribir el token, sin mirar ninguna preferencia. El interruptor quedaría
  // apagado en pantalla y los avisos volverían solos — o sea, seguiría
  // mintiendo, pero ahora con un dato falso guardado en el servidor. Respetarlo
  // de verdad exige tocar `_layout.tsx` y el backend, que están fuera de este
  // frente.
  //
  // Lo que SÍ existe hoy es el interruptor del sistema operativo, que bloquea
  // los avisos de verdad y lo controla el usuario. Es exactamente lo que ya
  // declara la Política de Privacidad (punto 9), así que las dos pantallas
  // dicen lo mismo. Este botón lleva ahí en un toque.
  const abrirAjustesDeNotificaciones = () => {
    Linking.openSettings().catch(() => {
      // Si el teléfono no deja abrir sus ajustes, se dice la ruta en vez de
      // dejar el botón mudo.
      Alert.alert(
        'Ábrelo desde los ajustes de tu teléfono',
        'Ajustes → Aplicaciones → Go Safely → Notificaciones. Desde ahí las enciendes o las apagas.'
      );
    });
  };

  const handleWhatsApp = () => {
    // ══════════════════════════════════════════════════════════════════════
    // VA AL ASISTENTE, NO DIRECTO AL WHATSAPP DEL FUNDADOR
    // ══════════════════════════════════════════════════════════════════════
    // Antes el número estaba escrito a mano como 809-555-0000, que NO EXISTE;
    // después pasó a ser el WhatsApp real del fundador. Las dos versiones
    // tenían el mismo problema de fondo: toda pregunta acababa en el teléfono
    // de UNA persona que además conduce.
    //
    // Las que más se repiten —por qué no puedo conectarme, cuándo me aprueban,
    // cómo mando el seguro— las contesta MEJOR el servidor, porque puede mirar
    // la cuenta de quien pregunta y responder con sus datos en vez de con un
    // texto general. Lo que toca dinero, multas o desbloquear algo se le sigue
    // pasando a él, pero con el diagnóstico ya hecho.
    //
    // El WhatsApp no desaparece: está dentro de esa pantalla. Quitarle a
    // alguien el camino que ya conocía, justo cuando viene con un problema, es
    // cambiarle el problema por dos.
    router.push('/ayuda' as any);
  };

  // ═══════════════════════════════════════════════════════════════════════
  // ELIMINAR MI CUENTA — ahora borra de verdad
  // ═══════════════════════════════════════════════════════════════════════
  //
  // ANTES ESTE BOTÓN MENTÍA. Solo escribía `pendingDeletion: true` en
  // /users/{uid} y cerraba sesión. NINGÚN proceso leía esa bandera: no había
  // cron, ni trigger, ni backend que la atendiera. Mientras tanto el diálogo
  // afirmaba que los datos "serán eliminados en un plazo de hasta 30 días" y
  // que el proceso "cumple con las políticas de Apple, Google y GDPR". Nada de
  // eso ocurría: el documento seguía intacto, la cuenta de Auth también, y al
  // volver a entrar reaparecía todo.
  //
  // Google Play exige (Data deletion policy, 2024) un borrado REAL y accesible
  // desde dentro de la app. Prometerlo sin hacerlo no es solo incumplir: es una
  // declaración falsa dentro del producto.
  //
  // Ahora: `solicitarBorradoDeCuenta` (functions/src/cuenta.ts) borra de
  // inmediato y el texto de abajo dice EXACTAMENTE qué desaparece, qué se
  // conserva sin nombre y por qué. No hay "30 días" que anunciar porque no hay
  // cola que procesar — y prometer un plazo que nadie cumple fue justo el
  // problema anterior.
  //
  // La confirmación es ESCRIBIR la palabra, no pulsar "Sí": un toque
  // accidental no puede destruir una cuenta que no se recupera.
  const [borrarVisible, setBorrarVisible] = React.useState(false);
  const [previaBorrado, setPreviaBorrado] = React.useState<{
    saldoQueSePierde: number;
    multaPendiente: number;
    bloqueos: string[];
    puedeBorrar: boolean;
  } | null>(null);
  const [previaError, setPreviaError] = React.useState<string | null>(null);
  const [cargandoPrevia, setCargandoPrevia] = React.useState(false);
  const [textoBorrado, setTextoBorrado] = React.useState('');
  const [borrando, setBorrando] = React.useState(false);
  const [errorBorrado, setErrorBorrado] = React.useState<string | null>(null);
  const [borradoHecho, setBorradoHecho] = React.useState(false);
  // Lo que el SERVIDOR dice que NO pudo terminar. La función siempre devolvía
  // esta lista y esta pantalla no la miraba: el acuse afirmaba "tus fotos y tus
  // documentos fueron eliminados" aunque hubieran quedado sin borrar.
  const [pendientesBorrado, setPendientesBorrado] = React.useState<string[]>([]);
  // Aviso de que no se pudo abrir WhatsApp desde el acuse (teléfono sin la app).
  const [avisoWhatsapp, setAvisoWhatsapp] = React.useState<string | null>(null);

  const abrirBorrarCuenta = async () => {
    setBorrarVisible(true);
    setPreviaBorrado(null);
    setPreviaError(null);
    setTextoBorrado('');
    setErrorBorrado(null);
    setBorradoHecho(false);
    setPendientesBorrado([]);
    setAvisoWhatsapp(null);
    setCargandoPrevia(true);
    try {
      // Modo previa: NO borra nada. Trae el saldo real y los viajes/pedidos en
      // curso, para que la pantalla hable con datos y no con un texto genérico.
      const data = await llamarBorradoDeCuenta({ previa: true });
      setPreviaBorrado({
        saldoQueSePierde: Number(data?.saldoQueSePierde ?? 0),
        multaPendiente: Number(data?.multaPendiente ?? 0),
        bloqueos: Array.isArray(data?.bloqueos) ? data.bloqueos : [],
        puedeBorrar: data?.puedeBorrar !== false,
      });
    } catch (e: any) {
      // Nada de relleno: si no pudimos consultar, se dice en pantalla.
      console.warn('[profile] previa de borrado falló:', e?.message ?? e);
      setPreviaError(
        'No pudimos consultar el estado de tu cuenta ahora mismo. Puedes continuar, ' +
        'pero no podemos mostrarte tu saldo actual: si te queda dinero en la billetera, se perderá.'
      );
    } finally {
      setCargandoPrevia(false);
    }
  };

  const confirmarBorrarCuenta = async () => {
    setBorrando(true);
    setErrorBorrado(null);
    // Fuera del `try` a propósito: el `catch` lo necesita para devolverle el
    // GPS al chofer si el servidor rechaza el borrado.
    const sesionDeViaje = await rideSessionStore.read();
    try {
      // APAGAR EL GPS ANTES DE BORRAR — no es una cortesía, es parte del
      // borrado. Si el usuario es chofer y está conectado, `locationService`
      // tiene un vigilante corriendo que cada 5-15 segundos escribe su posición
      // en /driverLocations/{uid} y la refleja en /drivers/{uid} (ver
      // `updateDriverLocation` en firestoreService.ts). Los dos documentos son
      // de los que borra la Cloud Function… y el vigilante seguía vivo después,
      // así que los volvía a crear con `set(..., {merge:true})` a los pocos
      // segundos: la ubicación en vivo de una cuenta eliminada, reapareciendo
      // sola en el mapa. Se detiene ANTES de llamar, no después, porque el
      // borrado tarda minutos y en ese rato ya habría escrito decenas de veces.
      // `stopTracking()` no falla si no había nada corriendo y en web no hace
      // nada, así que se llama sin condiciones.
      //
      // Se lee ANTES en qué estado estaba, porque el borrado puede ser
      // RECHAZADO (viaje en curso, bono sin cobrar…): si eso pasa, el chofer
      // sigue trabajando y no puede quedarse sin GPS por haber abierto este
      // modal. `rideSessionStore` guarda esa intención en disco —no
      // `getCurrentMode()`, que mira si hay una tarea de segundo plano
      // registrada y hoy SIEMPRE devuelve null: con UBICACION_SEGUNDO_PLANO
      // apagada el seguimiento va por `watchPositionAsync`, sin tarea.
      try {
        await locationService.stopTracking();
      } catch (e) {
        console.warn('[profile] no se pudo detener el GPS antes de borrar:', e);
      }

      const data = await llamarBorradoDeCuenta({ confirmacion: FRASE_BORRADO });

      // LO QUE EL SERVIDOR NO PUDO TERMINAR. `solicitarBorradoDeCuenta`
      // devuelve `pendientes` (los fallos ya traducidos a español). Si viene
      // con algo, el acuse tiene que decirlo: un borrado parcial anunciado como
      // completo deja al usuario creyendo que sus documentos ya no están.
      const pendientes: string[] = Array.isArray(data?.pendientes)
        ? data.pendientes.filter((p: any) => typeof p === 'string' && p.trim())
        : [];
      setPendientesBorrado(pendientes);

      // SOLO se marca el acuse. La sesión local NO se cierra todavía, y es a
      // propósito: el guard de `_layout.tsx` reacciona a que el rol quede en
      // null y hace `router.replace('/auth')`, lo que DESMONTA esta pantalla
      // —y con ella este modal— antes de que el usuario alcance a leer nada.
      // Acabaría en la pantalla de login sin saber si se borró o no.
      // Dejar la sesión viva unos segundos no abre ningún hueco: la cuenta de
      // Auth ya no existe en el servidor, así que ese token no sirve para nada.
      //
      // El acuse va DENTRO del modal y no en un Alert porque en web
      // `Alert.alert` de React Native no pinta nada.
      setBorradoHecho(true);
    } catch (e: any) {
      // EL BORRADO NO OCURRIÓ: hay que devolverle el GPS al chofer. El motivo
      // más común de este error es precisamente un compromiso vivo ("tienes un
      // viaje en curso"), o sea que la persona está trabajando ahora mismo. Sin
      // esto, abrir el modal y que el servidor dijera que no lo dejaba a mitad
      // de un viaje con el pasajero viendo su marcador congelado.
      if (sesionDeViaje.driverOnline && userFirebaseUid) {
        try {
          await locationService.startTracking(
            userFirebaseUid,
            sesionDeViaje.activeRideId && sesionDeViaje.activeRideRole === 'DRIVER'
              ? 'ACTIVE_RIDE'
              : 'IDLE'
          );
        } catch (e2) {
          console.warn('[profile] no se pudo restaurar el GPS tras un borrado rechazado:', e2);
        }
      }
      const codigo = String(e?.code ?? '');
      setErrorBorrado(
        codigo.includes('unauthenticated')
          ? 'Tu sesión expiró. Cierra sesión, vuelve a entrar e inténtalo otra vez.'
          : mensajeDeError(e, 'No pudimos eliminar tu cuenta. Vuelve a intentarlo o escríbenos por WhatsApp.')
      );
    } finally {
      setBorrando(false);
    }
  };

  // Cerrar el modal es también el momento de soltar la sesión: si el borrado se
  // completó, aquí se limpia todo y se sale. Si el usuario solo canceló, no se
  // toca nada.
  const cerrarModalBorrado = async () => {
    setBorrarVisible(false);
    if (!borradoHecho) return;

    // ═══ EL ORDEN DE ESTAS DOS LÍNEAS ES EL ARREGLO, NO UN DETALLE ═══
    //
    // `authBridge.signOut()` empieza por limpiar el token de push, y "limpiar"
    // ahí significa ESCRIBIR: `notificationService.clearPushToken(uid)` hace un
    // `set({pushToken:null, fcmToken:null}, {merge:true})` sobre
    // /users/{uid}. Con `merge:true`, escribir sobre un documento que ya no
    // existe NO falla: LO CREA. Y el token de una sesión recién borrada sigue
    // siendo válido para Firestore hasta que expira, así que la regla lo deja
    // pasar.
    //
    // Resultado real del bug: la Cloud Function borraba /users/{uid} entero…
    // y al pulsar "Entendido" esta pantalla lo resucitaba con dos campos en
    // null. El documento del usuario NUNCA quedaba borrado. Justo lo que Google
    // comprueba cuando revisa la política de eliminación de cuentas: la app
    // promete que el dato desaparece y el dato sigue ahí.
    //
    // `resetSession()` PRIMERO deja `userFirebaseUid` en null, y signOut solo
    // limpia el token `if (uid)` — sin uid no escribe nada. Además esta
    // limpieza es la que borra del teléfono el nombre, el correo, la foto y la
    // placa (el store está persistido en disco con AsyncStorage), así que
    // hacerla antes también la vuelve incondicional: si signOut reventara, los
    // datos del usuario ya no estarían en el aparato.
    const store = useAppStore.getState();
    store.resetSession();

    try {
      await authBridge.signOut();
    } catch (e) {
      console.warn('[profile] signOut tras borrado falló:', e);
    }
    // Olvidar el código de referido cacheado: el próximo usuario de este
    // teléfono no debe heredar el de una cuenta que ya no existe.
    try {
      const { referralService } = await import('../../services/referralService');
      referralService.resetCache();
    } catch {}

    // Segunda pasada de la limpieza local. `signOut()` llama por dentro a
    // `resetSession()`, pero si esa llamada revienta antes de llegar ahí (el
    // catch de arriba se la traga) el store se quedaría a medias. Repetirlo es
    // gratis —es un `set` de Zustand— y garantiza que en el teléfono no queden
    // ni el nombre, ni el correo, ni la foto, ni la placa: el store está
    // PERSISTIDO en disco (AsyncStorage, `go-safely-storage-v2`) y prometer
    // "borramos tus datos" dejándolos en el aparato es la misma contradicción
    // que revisa Google.
    useAppStore.getState().resetSession();
    router.replace('/');
  };

  const puedeConfirmarBorrado =
    textoBorrado.trim().toUpperCase() === FRASE_BORRADO &&
    !borrando &&
    !cargandoPrevia &&
    (previaBorrado?.puedeBorrar ?? true);

  /**
   * ¿ESTE NEGOCIO EXISTE DE VERDAD, O SOLO SE ASOMO?
   *
   * La prueba es la MISMA que usa el servidor para decidir si le deja cambiar
   * de modo: la existencia de /restaurants/{uid}. Ese documento solo lo crea
   * el registro de negocio (`allow create` de /restaurants), asi que existir
   * ES la prueba. Ver functions/src/modoDeUsuario.ts:98.
   *
   * Hace falta aqui porque la tarjeta «Cambiar a Pasajero» NO se puede quitar
   * a secas: para quien solo TOCO «Tengo un Negocio» en la portada es su unica
   * salida —el rol ya quedo escrito en /users y «Cerrar Sesion» no lo borra,
   * auth.tsx lo restaura en el siguiente login—. Al dueno registrado la
   * tarjeta no le servia de nada (el servidor ya le niega el cambio): era un
   * boton muerto en medio de su perfil profesional.
   *
   * Si la lectura falla se queda en false, o sea que la tarjeta se SIGUE
   * viendo: por un bache de red nadie se queda encerrado.
   */
  const [negocioRegistrado, setNegocioRegistrado] = React.useState(false);
  React.useEffect(() => {
    if (role !== 'RESTAURANT_OWNER' || !userFirebaseUid) {
      setNegocioRegistrado(false);
      return;
    }
    let vivo = true;
    firestoreService
      .getRestaurantById(userFirebaseUid)
      .then((r: any) => { if (vivo) setNegocioRegistrado(!!r); })
      .catch((e: any) => console.warn('[profile] no se pudo leer el negocio:', e?.message));
    return () => { vivo = false; };
  }, [role, userFirebaseUid]);

  const isDark = theme === 'dark';

  return (
    <ScreenBackground>
      <SafeAreaView style={styles.safeArea}>
        <ScrollView contentContainerStyle={styles.container} showsVerticalScrollIndicator={false}>
          <Text style={[styles.pageTitle, { color: colors.text }]}>Configuración</Text>

          <AvisoVistaPrevia que="tu perfil" />

          {/* RECORDATORIO PAPEL DE BUENA CONDUCTA — solo para motoconchos
              y repartidores en moto al final de su trial de 30 días.
              Después de los 30 días sin papel no pueden seguir trabajando. */}
          {showConductReminder && (
            <TouchableOpacity
              onPress={() => router.push('/kyc-documents' as any)}
              activeOpacity={0.85}
              style={{
                backgroundColor: trialExpiredBlocked ? '#FF3B30' : '#FF9500',
                borderRadius: 14,
                padding: 14,
                marginBottom: 14,
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Ionicons name="document-text" size={28} color="#FFF" style={{ marginRight: 12 }} />
              <View style={{ flex: 1 }}>
                <Text style={{ color: '#FFF', fontWeight: '800', fontSize: 14, marginBottom: 2 }}>
                  {trialExpiredBlocked
                    ? '🚨 Tu trial venció — Sube tu Papel de Buena Conducta para seguir trabajando'
                    : `⏰ Tu trial vence en ${driverTrialDaysLeft} día${driverTrialDaysLeft === 1 ? '' : 's'}`}
                </Text>
                <Text style={{ color: 'rgba(255,255,255,0.92)', fontSize: 12, lineHeight: 16 }}>
                  Sube tu <Text style={{ fontWeight: 'bold' }}>Papel de Buena Conducta</Text> emitido por la Procuraduría (menos de 30 días de antigüedad) para mantener tu cuenta activa.
                </Text>
              </View>
              <Ionicons name="chevron-forward" size={18} color="#FFF" />
            </TouchableOpacity>
          )}

          {/* TARJETA DE PERFIL */}
          <TouchableOpacity 
            style={[styles.profileCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} 
            onPress={() => {
              if (bloquearSiInvitado('editar tu perfil')) return;
              router.push('/edit-profile');
            }}
          >
            <View style={styles.avatarContainer}>
              {userPhoto ? (
                <Image source={{ uri: userPhoto }} style={styles.avatarImage} />
              ) : (
                <Ionicons name="person" size={40} color="#FFF" />
              )}
              {isVerified && (
                <View style={styles.verifiedBadge}>
                  <Ionicons name="checkmark-circle" size={24} color="#4CAF50" />
                </View>
              )}
            </View>
            <View style={styles.profileInfo}>
              <Text style={[styles.profileName, { color: colors.text }]}>{storeName || 'Usuario Nuevo'}</Text>
              
              {/* ══════════════════════════════════════════════════════════
                  LA NOTA Y EL RANGO — ANTES ERAN UN DIBUJO
                  ══════════════════════════════════════════════════════════
                  Aquí había cinco estrellas VACÍAS y el texto literal
                  «0.0 (Nuevo)», escrito a mano, igual para todo el mundo: un
                  chofer con 4.9 de nota y doscientos viajes veía «0.0
                  (Nuevo)». Los campos reales (`driverRatingAvg`,
                  `driverRatingCount`) los escribe functions/src/ratings.ts y
                  no los leía nadie.
                  Y faltaba el RANGO que pidió el fundador: lo calcula
                  functions/src/niveles.ts desde hace semanas, pero el único
                  sitio que lo leía era la ficha que ve el PASAJERO. El chofer
                  se ganaba un rango y no podía verlo. */}
              {/* ══ EL RANGO ES POR VIAJES, Y UN NEGOCIO NO HACE VIAJES ══════
                  Sin este filtro, el dueño de un restaurante abría su perfil y
                  leía «BRONCE — 0 viajes · te faltan 15 viajes para PLATA». Es
                  la misma clase de cosa que el fundador vio en su cuenta y
                  llamó, con razón, «poco profesional»: el rango de otro perfil
                  pegado en el suyo, y encima prometiéndole algo que no puede
                  conseguir.
                  La nota del negocio existe, pero es OTRA — la que le ponen
                  sus clientes, y vive en `/restaurants/{uid}` y en su panel.
                  Los tres de la lista son los que no se suben a un carro: el
                  negocio, el dueño de la flota y el director. El CAR_RENTER
                  sí hace viajes (alquila para trabajar), así que conserva el
                  suyo. */}
              {!SIN_RANGO_DE_VIAJES.includes(role ?? '') && (
                <BarraDeNivel
                  uid={userFirebaseUid}
                  esChofer={role === 'DRIVER' || role === 'SCHOOL_DRIVER' || role === 'DELIVERY_DRIVER'}
                />
              )}

              <Text style={[styles.profilePhone, { color: colors.textSecondary }]}>{storePhone || 'Configura tu perfil'}</Text>
              <View style={styles.roleBadge}>
                <Text style={styles.roleBadgeText}>
                  {role === 'PASSENGER' 
                    ? 'PASAJERO' 
                    : role === 'DRIVER' 
                      ? 'CONDUCTOR' 
                      : role === 'SCHOOL_DIRECTOR' 
                        ? 'DIRECTOR DE ESCUELA' 
                        : role === 'RENT_CAR_OWNER' 
                          ? 'RENT CAR (DUEÑO)' 
                          : role === 'FOOD_DELIVERY'
                            ? 'USUARIO DELIVERY'
                            : role === 'RESTAURANT_OWNER'
                              ? 'RESTAURANTE (DUEÑO)'
                              : 'INVITADO'}
                </Text>
              </View>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          {/* MODO DE USUARIO — o MI NEGOCIO, que no es lo mismo */}
          <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>
            {negocioRegistrado ? 'MI NEGOCIO' : 'MODO DE USUARIO'}
          </Text>
          
          {role === 'PASSENGER' ? (
            <>
            <TouchableOpacity
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
              onPress={() => {
                // Sin cuenta este camino acaba en kyc-documents, que al tomar la foto
                // dice "Sesión no detectada. Cierra la app y vuelve a iniciar sesión".
                if (bloquearSiInvitado('cambiar de rol')) return;
                // ══════════════════════════════════════════════════════════
                // ESTA TARJETA CONVERTÍA A UN DUEÑO DE NEGOCIO EN CHOFER
                // ══════════════════════════════════════════════════════════
                //
                // Lo que había era esto:
                //
                //   const destino = base === 'RENT_CAR_OWNER'
                //                || base === 'SCHOOL_DIRECTOR' ? base : 'DRIVER';
                //
                // O sea que cualquier otro `baseRole` caía en el `else` y
                // acababa en 'DRIVER'. El caso concreto: el dueño de un
                // restaurante o una farmacia que se pasó a pasajero veía una
                // tarjeta que le decía «Regresa a tu perfil de negocio»
                // —porque el subtítulo solo mira que `baseRole` exista— la
                // tocaba, y se convertía en CHOFER DE TAXI, con su viaje al
                // KYC de conductor. La misma tarjeta se contradecía a sí
                // misma: el título decía «Cambiar a Chofer» y el subtítulo
                // «Regresa a tu perfil de negocio».
                //
                // Ahora el destino es el `baseRole` de verdad cuando ese rol
                // tiene panel propio, y la navegación sale de `rutaSegunRol`,
                // que es la tabla que ya decide dónde aterriza cada rol. Así
                // esto no se vuelve a quedar viejo el día que se añada otro
                // rol — que es exactamente lo que pasó aquí.
                const base = useAppStore.getState().baseRole;
                const destino = base && CON_PANEL_PROPIO.includes(base) ? base : 'DRIVER';
                cambiarDeModo(destino, () => {
                  const store = useAppStore.getState();
                  if (destino !== 'DRIVER') {
                    store.setRole(destino as any);
                    router.replace(rutaSegunRol(destino) as any);
                    return;
                  }
                  // Si nunca completó KYC como conductor, lo enviamos al onboarding.
                  // Si ya está verificado, va directo al mapa con su rol DRIVER.
                  store.setRole('DRIVER');
                  // Tercer sitio con la misma ceguera (los otros dos eran
                  // index.tsx y role-selection.tsx): si en esta sesion ya se le
                  // recordo la verificacion y la aplazo, no se le vuelve a
                  // poner delante. Conducir sigue cerrado hasta verificarse —
                  // eso lo guarda el servidor, no esta pantalla.
                  if (!store.isDriverVerified && !verificacionAplazadaEnEstaSesion()) {
                    aplazarVerificacionEnEstaSesion();
                    router.push('/kyc-welcome');
                  } else {
                    router.replace('/(tabs)/map');
                  }
                });
              }}
            >
              <View style={styles.actionIconContainer}>
                <Ionicons name="car" size={24} color={colors.primary} />
              </View>
              <View style={styles.actionTextContainer}>
                {/* El título y el subtítulo salen del MISMO dato que decide a
                    dónde va el botón. Antes no: el título miraba dos roles y
                    el subtítulo solo miraba que `baseRole` existiera, así que
                    a un dueño de restaurante le decía «Cambiar a Chofer» y
                    «Regresa a tu perfil de negocio» a la vez. */}
                <Text style={[styles.actionTitle, { color: colors.text }]}>
                  {useAppStore.getState().baseRole === 'RENT_CAR_OWNER' ? 'Volver a Rent Car' :
                   useAppStore.getState().baseRole === 'SCHOOL_DIRECTOR' ? 'Volver a Director(a)' :
                   useAppStore.getState().baseRole === 'RESTAURANT_OWNER' ? 'Volver a mi Negocio' :
                   'Cambiar a Chofer (Taxi / Motor)'}
                </Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                  {['RENT_CAR_OWNER', 'SCHOOL_DIRECTOR', 'RESTAURANT_OWNER']
                    .includes(useAppStore.getState().baseRole ?? '')
                    ? 'Regresa a tu panel'
                    : useAppStore.getState().isDriverVerified ? 'Empieza a aceptar viajes' : 'Verifica tus documentos para empezar'}
                </Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>

            {/* Opción dedicada: Repartidor de Comida (separado del conductor de taxi) */}
            {!useAppStore.getState().baseRole && (
              <TouchableOpacity
                style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
                onPress={() => {
                  // Sin cuenta este camino acaba en kyc-documents, que al tomar la foto
                  // dice "Sesión no detectada. Cierra la app y vuelve a iniciar sesión".
                  if (bloquearSiInvitado('cambiar de rol')) return;
                  cambiarDeModo('DELIVERY_DRIVER', () => {
                    const store = useAppStore.getState();
                    store.setRole('DELIVERY_DRIVER');
                    // Mismo criterio que el modo chofer de mas arriba.
                    if (!store.isDriverVerified && !verificacionAplazadaEnEstaSesion()) {
                      aplazarVerificacionEnEstaSesion();
                      router.push('/kyc-welcome');
                    } else {
                      router.replace('/(tabs)/map');
                    }
                  });
                }}
              >
                <View style={[styles.actionIconContainer, { backgroundColor: 'rgba(255, 149, 0, 0.1)' }]}>
                  <Ionicons name="bicycle" size={24} color="#FF9500" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Cambiar a Repartidor de Comida</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                    {useAppStore.getState().isDriverVerified ? 'Solo entregas, sin viajes de pasajeros' : 'Verifica tus documentos para empezar'}
                  </Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            )}
            </>
          ) : role === 'FOOD_DELIVERY' ? (
            <TouchableOpacity 
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} 
              onPress={() => {
                cambiarDeModo('PASSENGER', () => {
                  useAppStore.getState().setRole('PASSENGER');
                  router.replace('/(tabs)/map');
                });
              }}
            >
              <View style={styles.actionIconContainer}>
                <Ionicons name="car" size={24} color={colors.primary} />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Solicitar un Viaje</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Ir a la app de transporte</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          ) : negocioRegistrado ? (
            /* AL NEGOCIO REGISTRADO NO SE LE OFRECE «CAMBIAR A PASAJERO».
               Su perfil es profesional, y esa tarjeta ademas no hacia nada:
               el servidor ya le niega el cambio (`buscarLaPrueba`,
               functions/src/modoDeUsuario.ts:98). Su puerta es «Mi Negocio»,
               unas lineas mas abajo.
               Quien solo se asomo SI la conserva: para el es la unica salida
               —el rol ya quedo escrito en /users y «Cerrar Sesion» no lo
               borra, auth.tsx lo restaura en el siguiente login—.

               En su lugar va «Mi Negocio», que ademas es su UNICA puerta
               visible de vuelta al panel: la barra de pestanas ya no se
               dibuja para el. Dejar este hueco en blanco bajo el encabezado
               «MI NEGOCIO» era cambiar un problema por otro con la misma
               pinta. */
            <TouchableOpacity
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
              onPress={() => router.replace('/restaurant-dashboard' as any)}
            >
              <View style={[styles.actionIconContainer, { backgroundColor: isDark ? '#4a3a0d' : '#FFF8E1' }]}>
                <Ionicons name="storefront" size={24} color="#FF8F00" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Mi Negocio</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Tu panel: productos, pedidos y ofertas</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          ) : (
            <TouchableOpacity 
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} 
              onPress={() => {
                cambiarDeModo('PASSENGER', () => {
                  useAppStore.getState().setRole('PASSENGER');
                  router.replace('/(tabs)/map');
                });
              }}
            >
              <View style={styles.actionIconContainer}>
                <Ionicons name="person" size={24} color={colors.primary} />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Cambiar a Pasajero</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Vuelve al modo pasajero</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {/* FINANZAS Y RECOMPENSAS */}
          <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>FINANZAS Y RECOMPENSAS</Text>
          
          <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/wallet')}>
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#1a3b5c' : '#E3F2FD'}]}>
              <Ionicons name="wallet" size={24} color="#2196F3" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>Mi Billetera</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Recargas y balance</Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          {/* MI SUSCRIPCIÓN — solo roles de chofer. Antes esta pantalla
              estaba huérfana (solo accesible vía un alert dentro del
              mapa). El chofer ahora puede gestionar su trial de 30 días,
              ver crédito acumulado, agregar tarjeta o recargar billetera
              por transferencia para pagar la cuota mensual. */}
          {(role === 'DRIVER' || role === 'SCHOOL_DRIVER' || role === 'DELIVERY_DRIVER') && (
            <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/driver-subscription' as any)}>
              <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#1a4a3b' : '#E8F5E9'}]}>
                <Ionicons name="ribbon" size={24} color="#00C853" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Mi cuota de servicio</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Trial 30 días · tarjeta o transferencia</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {/* FIX AUDIT SCHOOL — Entrada para que el chofer escolar publique su
              ruta (colegios que sirve) y sea descubrible por padres/directoras. */}
          {/* MI VEHÍCULO — foto, color y placa, como Uber e InDriver.
              El KYC pedía las cinco fotos del carro y los datos, pero el perfil
              no mostraba ninguno: el chofer subía todo y su vehículo
              desaparecía de su vista. */}
          {(role === 'DRIVER' || role === 'DELIVERY_DRIVER' || role === 'SCHOOL_DRIVER') && (
            <TarjetaMiVehiculo />
          )}

          {VERTICAL_ESCOLAR_VISIBLE && (role === 'DRIVER' || role === 'SCHOOL_DRIVER') && (
            <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/school-driver-setup' as any)}>
              <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#0d3a4a' : '#E0F7FA'}]}>
                <Ionicons name="bus" size={24} color="#00796B" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Mi Ruta Escolar</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Publica tus colegios para que te encuentren</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {role === 'DRIVER' && (
            <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/driver-bank-accounts' as any)}>
              <View style={[styles.actionIconContainer, {backgroundColor: 'rgba(0, 102, 255, 0.1)'}]}>
                <Ionicons name="business" size={24} color="#0066FF" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Cuentas de Transferencia</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Agrega tus bancos para pasajeros</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {/* ⚠ A UN NEGOCIO NO SE LE OFRECE «MANTENIMIENTO VEHÍCULO».
              Esta tarjeta se pintaba SIEMPRE, y su rótulo era
              `role === 'PASSENGER' ? 'Invita y Gana' : 'Mantenimiento Vehículo'`.
              O sea que todo lo que no fuera pasajero caía en el `else`: el dueño
              de un restaurante abría su perfil y leía «Mantenimiento Vehículo —
              Bonos por viajes y referidos». Es lo que el fundador vio en su
              propia cuenta y llamó, con razón, «poco profesional».
              Y no es solo el rótulo: lo que hay detrás son bonos por VIAJES, que
              un negocio no hace. */}
          {!esNegocio && (
          <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => setRewardsVisible(true)}>
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#3b1a5c' : '#F3E5F5'}]}>
              <Ionicons name="gift" size={24} color="#9C27B0" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>
                {role === 'PASSENGER' || role === 'FOOD_DELIVERY' ? 'Invita y Gana' : 'Mantenimiento Vehículo'}
              </Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                {role === 'PASSENGER' || role === 'FOOD_DELIVERY' ? 'Viajes gratis' : 'Bonos por viajes y referidos'}
              </Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>
          )}

          {/* ══ LA VUELTA A SU PANEL ════════════════════════════════════════
              El panel del negocio vive FUERA de las pestañas
              (`/restaurant-dashboard`), así que una vez el dueño entra en
              Perfil no tiene cómo volver: la flecha lo deja aquí y la barra de
              abajo ya no le enseña Viaje ni Actividad — bien, porque no le
              tocan, pero entonces le hace falta esta puerta.
              Sin ella, el arreglo de las pestañas lo dejaría encerrado, que es
              cambiar un problema por otro peor. */}
          {/* La tarjeta «Mi Negocio» se movió ARRIBA, a la sección «MI
              NEGOCIO», que es donde la busca un dueño. Aquí quedaba archivada
              debajo de la billetera, y el encabezado de arriba se quedaba
              vacío. Solo se sigue pintando aquí para el dueño cuyo negocio
              todavía no está registrado, que arriba ve «Cambiar a Pasajero». */}
          {role === 'RESTAURANT_OWNER' && !negocioRegistrado && (
            <TouchableOpacity
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
              onPress={() => router.replace('/restaurant-dashboard' as any)}
            >
              <View style={[styles.actionIconContainer, { backgroundColor: isDark ? '#4a3a0d' : '#FFF8E1' }]}>
                <Ionicons name="storefront" size={24} color="#FF8F00" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Mi Negocio</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Volver a tu panel: productos, pedidos y ofertas</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {/* CUENTA Y SEGURIDAD */}
          <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>CUENTA Y SEGURIDAD</Text>
          {/* FIX VERIFICACIÓN — Antes este botón siempre rotuiaba a
              /kyc-welcome, lo que mandaba al user verificado de vuelta al
              picker de vehículos como si tuviera que reempezar el KYC.
              Ahora: si ya está verificado, mostramos confirmación con la
              lista de documentos aprobados; si NO está, lo llevamos al
              embudo para completarlo. */}
          <TouchableOpacity
            style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
            onPress={() => {
              if (bloquearSiInvitado('verificar tu identidad')) return;
              if (isVerified) {
                const store = useAppStore.getState();
                const isDriverVerified = !!store.isDriverVerified;
                const driverItems = isDriverVerified
                  ? '\n• Licencia de Conducir\n• Matrícula del vehículo\n• Seguro vigente\n• Fotos del vehículo'
                  : '';
                // "Selfie biométrica" decía biometría donde no la hay: la
                // comparación la hace una persona (reviewKycSubmission), no un
                // sistema de reconocimiento facial, y así lo declaran los
                // Términos y la Política. Es la misma frase por la que hubo que
                // renombrar la pantalla de abajo.
                Alert.alert(
                  '✓ Identidad Verificada',
                  `Tus documentos están aprobados:\n\n• Cédula (frente y dorso)\n• Tu selfie${driverItems}\n\nNo necesitas hacer nada más.`,
                  [{ text: 'Entendido' }]
                );
                return;
              }
              router.push('/kyc-welcome');
            }}
          >
            <View style={[styles.actionIconContainer, isVerified && { backgroundColor: 'rgba(76, 175, 80, 0.15)' }]}>
              <Ionicons name="shield-checkmark" size={24} color={isVerified ? '#4CAF50' : colors.primary} />
            </View>
            <View style={styles.actionTextContainer}>
              {/* "Estado de tu verificación" y no "Verificación de identidad":
                  la tarjeta de abajo (la que abre /biometrics-settings) pasó a
                  llamarse así al quitarle el nombre falso de "Biometría", y dos
                  tarjetas con el MISMO título en la misma sección, llevando a
                  sitios distintos, es un laberinto. Esta muestra el estado y
                  lleva al embudo; la otra explica qué se pide y por qué. */}
              <Text style={[styles.actionTitle, { color: colors.text }]}>Estado de tu verificación</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                {isVerified ? 'Aprobada ✓' : 'Pendiente — completa tu verificación'}
              </Text>
            </View>
            <Ionicons
              name={isVerified ? 'checkmark-circle' : 'chevron-forward'}
              size={20}
              color={isVerified ? '#4CAF50' : colors.textSecondary}
            />
          </TouchableOpacity>

          {/* MÉTODOS DE PAGO — oculto mientras el pago con tarjeta esté apagado.
              Esta tarjeta llevaba a una pantalla cuyo único botón ("Agregar
              nueva tarjeta") llamaba al backend de Railway, que fue borrado:
              fallaba SIEMPRE con "No se pudo conectar con el servidor de
              pagos". Estaba a dos toques de la barra de pestañas — el caso
              de libro del rechazo vc13 ("botones que no responden").
              Vuelve sola cuando PLATFORM_CARD_ENABLED pase a true. */}
          {PLATFORM_CARD_ENABLED && (
            <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/payment-methods')}>
              <View style={styles.actionIconContainer}>
                <Ionicons name="card" size={24} color={colors.primary} />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Métodos de Pago</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Gestionar tarjetas</Text>
              </View>
              <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          {/* ESTA TARJETA DECÍA "Seguridad Biometría / Autenticación Facial" y
              el icono era un escáner. Nada de eso existe: la pantalla que abre
              (/biometrics-settings) ya se corrigió para explicar que la
              comparación la hace UNA PERSONA del equipo, y que no hay
              reconocimiento facial, ni prueba de vida, ni plantillas del
              rostro. O sea que el botón anunciaba una cosa y la pantalla decía
              la contraria — y la Política de Privacidad está del lado de la
              pantalla. El revisor de Google compara los tres textos: una
              declaración de datos biométricos que no cuadra con la política es
              rechazo, no observación. Nombre e icono ahora dicen lo que de
              verdad se pide: la cédula y una selfie. */}
          <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/biometrics-settings')}>
            <View style={styles.actionIconContainer}>
              <Ionicons name="id-card-outline" size={24} color={colors.primary} />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>Verificación de identidad</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Tu cédula y tu selfie</Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          {VERTICAL_ESCOLAR_VISIBLE && role === 'PASSENGER' && (
            <>
              <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>FAMILIA</Text>
              <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/students')}>
                <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#1a3b5c' : '#E3F2FD'}]}>
                  <Ionicons name="school" size={24} color={colors.primary} />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Mis Hijos</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Gestionar transporte de tus hijos</Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </>
          )}

          {/* ══ LOGÍSTICA ═════════════════════════════════════════════════
              La puerta que pidió el fundador: «que se acceda directamente desde
              el perfil que ya el usuario de pasajero tenga creado».

              Está AQUÍ y no arriba, en el bloque de choferes, a propósito: ese
              bloque solo se pinta para los tres roles de chofer, y entonces un
              pasajero con una camioneta —que es justo a quien va dirigido— no
              la vería nunca.

              Y NO es un cambio de modo. No toca `setRole`: el dueño de la
              camioneta sigue siendo pasajero y se le añade una capacidad. Si
              alguna vez esto empieza a cambiarle el rol, deja de poder pedirse
              un viaje — lo contrario de lo que se pidió.

              Fuera de los dos roles de NEGOCIO por la regla del fundador:
              «negocios son negocios; si desean pasar a pasajero deben usar esa
              cuenta». Una cuenta de restaurante o de rent car no se mezcla con
              un gremio de transporte. */}
          {VERTICAL_LOGISTICA_VISIBLE && !esNegocio && (
            <>
              <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>LOGÍSTICA Y CARGA</Text>
              <TouchableOpacity
                style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
                onPress={() => {
                  // Sin cuenta este camino acaba en una pantalla que pide subir
                  // cuatro fotos a Storage y falla al primer toque.
                  if (bloquearSiInvitado('registrar tu vehículo de carga')) return;
                  router.push('/logistica' as any);
                }}
              >
                <View style={[styles.actionIconContainer, { backgroundColor: isDark ? '#3d2a0a' : '#FFF3E0' }]}>
                  <Ionicons name="cube" size={24} color="#EF6C00" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Transporte de Carga</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                    Curier, mudanza, carga y autobús para gira
                  </Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </>
          )}

          {role === 'FOOD_DELIVERY' && (
            <>
              <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>MIS PEDIDOS</Text>
              <TouchableOpacity
                style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
                onPress={() => router.push('/(tabs)/activity')}
                activeOpacity={0.8}
              >
                <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#3b1a5c' : '#F3E5F5'}]}>
                  <Ionicons name="receipt" size={24} color="#9C27B0" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Historial de Pedidos</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Tus restaurantes y recibos</Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>

              <TouchableOpacity
                style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
                onPress={() => router.push('/addresses')}
                activeOpacity={0.8}
              >
                <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#1a3b5c' : '#E3F2FD'}]}>
                  <Ionicons name="location" size={24} color="#2196F3" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Mis Direcciones</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Casa, trabajo y otros</Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </>
          )}

          {role === 'RENT_CAR_OWNER' && (
            <>
              <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>CONFIGURACIÓN RENT CAR</Text>
              <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/crm-settings')}>
                <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#3b1a5c' : '#F3E5F5'}]}>
                  <Ionicons name="people" size={24} color="#9C27B0" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Configurar CRM</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>API y gestión de clientes y flota</Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </>
          )}

          {VERTICAL_ESCOLAR_VISIBLE && role === 'SCHOOL_DRIVER' && (
            <>
              <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>TRANSPORTE ESCOLAR</Text>
              <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={() => router.push('/school-route')}>
                <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#4d300b' : '#FFF3E0'}]}>
                  <Ionicons name="school" size={24} color="#FF9800" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: colors.text }]}>Mi Ruta Escolar</Text>
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Código de ruta, alumnos y rastreo</Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
              </TouchableOpacity>
            </>
          )}

          {/* PREFERENCIAS */}
          <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>PREFERENCIAS</Text>

          {/* En web no hay a qué ajustes llevar (Linking.openSettings no existe
              en el navegador) y la app tampoco envía push ahí, así que la fila
              no se muestra en vez de ofrecer un botón que no puede hacer nada.
              El detalle de por qué esto ya no es un interruptor está arriba, en
              `abrirAjustesDeNotificaciones`. */}
          {Platform.OS !== 'web' && (
            <TouchableOpacity
              style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
              onPress={abrirAjustesDeNotificaciones}
            >
              <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#4d300b' : '#FFF3E0'}]}>
                <Ionicons name="notifications" size={24} color="#FF9800" />
              </View>
              <View style={styles.actionTextContainer}>
                <Text style={[styles.actionTitle, { color: colors.text }]}>Notificaciones</Text>
                <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                  Se encienden y se apagan en los ajustes de tu teléfono
                </Text>
              </View>
              <Ionicons name="open-outline" size={20} color={colors.textSecondary} />
            </TouchableOpacity>
          )}

          <View style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}>
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#2c1952' : '#EDE7F6'}]}>
              <Ionicons name="moon" size={24} color="#673AB7" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>Modo Oscuro</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Cambiar apariencia</Text>
            </View>
            <Switch 
              value={theme === 'dark'}
              onValueChange={(val) => setTheme(val ? 'dark' : 'light')}
              trackColor={{ false: "#767577", true: colors.accent }}
              thumbColor={theme === 'dark' ? "#fff" : "#f4f3f4"}
            />
          </View>

          {/* SOPORTE */}
          <Text style={[styles.sectionTitle, { color: colors.textSecondary }]}>SOPORTE Y LEGAL</Text>

          <TouchableOpacity style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]} onPress={handleWhatsApp}>
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#1a3d24' : '#E8F5E9'}]}>
              <Ionicons name="logo-whatsapp" size={24} color="#4CAF50" />
            </View>
            <View style={styles.actionTextContainer}>
              {/* Decía "Chat 24/7". Detrás de este WhatsApp hay UNA persona y
                  UN número (SOPORTE_TELEFONO en constants/contacto.ts, el
                  mismo que usan terms.tsx punto 16 y PenaltyGate): prometer
                  atención permanente es una promesa que nadie puede cumplir, y
                  la lee alguien que ya viene con un problema. */}
              <Text style={[styles.actionTitle, { color: colors.text }]}>Ayuda</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                Te decimos qué tienes pendiente al momento
              </Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          {/* FIX — Antes este botón solo lanzaba `Alert.alert('Información',
              'Términos y Políticas de Privacidad')`: un diálogo negro con esa
              frase y nada más. Las pantallas /terms y /privacy SÍ existen y
              están completas (Ley 172-13), pero nadie las abría. Además Google
              Play exige que el usuario pueda LEER la política dentro de la app.
              Ahora son dos accesos reales y separados. */}
          <TouchableOpacity
            style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
            onPress={() => router.push('/terms' as any)}
          >
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#333' : '#F5F5F5'}]}>
              <Ionicons name="document-text" size={24} color="#757575" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>Términos y Condiciones</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Reglas de uso del servicio</Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          <TouchableOpacity
            style={[styles.actionCard, { backgroundColor: colors.card, borderColor: colors.border, borderWidth: 1 }]}
            onPress={() => router.push('/privacy' as any)}
          >
            <View style={[styles.actionIconContainer, {backgroundColor: isDark ? '#333' : '#F5F5F5'}]}>
              <Ionicons name="lock-closed" size={24} color="#757575" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>Política de Privacidad</Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>Cómo protegemos tus datos</Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={colors.textSecondary} />
          </TouchableOpacity>

          {/* ══════════════════════════════════════════════════════════════
              MODO DEMOSTRACIÓN — PÚBLICO Y PERMANENTE
              ══════════════════════════════════════════════════════════════

              ── POR QUÉ ESTO SALIÓ DEL BLOQUE `__DEV__` ────────────────────

              El viaje simulado existía desde hace tiempo, pero su único
              interruptor estaba dentro del panel de QA, o sea detrás de
              `__DEV__`: NO EXISTE en el binario que se sube a la tienda.

              Y eso es justo lo que rompe la revisión de Apple. Un revisor abre
              la app en California, donde no hay ni un chofer conectado, y no
              puede completar un viaje: pide uno, la pantalla gira, y a los seis
              minutos se rinde. La guideline 2.1 exige que el revisor pueda
              ejercitar la función principal; cuando no puede, el rechazo dice
              «we were unable to review the core functionality of your app», que
              es el rechazo más repetido en apps de este tipo.

              Pero no es solo para Apple: a cualquiera que instale la app en un
              barrio sin choferes todavía le pasa lo mismo. Poder ver cómo
              funciona un viaje sin depender de que haya alguien conectado es
              una función de producto, no un apaño para pasar una revisión.

              ── LO QUE **NO** SALIÓ, Y NO PUEDE SALIR NUNCA ───────────────

              Debajo sigue el bloque `__DEV__`, y ahí se queda lo peligroso:
              saltarse la verificación de identidad y cambiarse de rol a mano
              (que además hace `setDriverVerified(true)`). Si eso llegara a un
              binario público, cualquiera se haría chofer verificado desde su
              propio teléfono. Se sacó SOLO el viaje simulado.

              ── LAS TRES DEFENSAS ─────────────────────────────────────────

              Lo peor que puede pasar aquí es que alguien se deje esto puesto,
              pida un viaje creyendo que es real, y se quede esperando en una
              acera a un chofer que no existe. Contra eso:
                1. `components/CintilloDemostracion.tsx`, que no se quita del
                   mapa mientras el modo esté encendido.
                2. El modo SE APAGA SOLO al terminar el viaje simulado.
                3. No se puede encender con un viaje de verdad en curso — es la
                   comprobación de aquí abajo.
              ─────────────────────────────────────────────────────────────── */}
          {/* ⚠️ SOLO AL PASAJERO, Y NO ES POR GUSTO.
              La tarjeta estaba sin condición de rol, así que la veían los seis:
              pasajero, chofer, repartidor, dueño de restaurante, dueño de rent
              car y arrendatario. Pero el modo SOLO hace algo en la rama del
              pasajero — el viaje simulado vive dentro de `solicitarViaje` y el
              cintillo se pinta bajo `role === 'PASSENGER'`. Para tres de esos
              roles la pestaña del mapa ni siquiera existe
              ((tabs)/_layout.tsx le pone `href: null`).
              O sea: tocaban una tarjeta que promete enseñarles cómo funciona un
              viaje y NO PASABA ABSOLUTAMENTE NADA. Ni cintillo, ni demostración,
              ni aviso. Es el mismo patrón por el que Google ya rechazó esta app
              dos veces («botones que no responden»), y encima el único aviso de
              que el modo está puesto no se dibujaba para ellos.
              Quien entra con otro rol tiene «Cambiar a Pasajero» ahí arriba. */}
          {role === 'PASSENGER' && (
          <TouchableOpacity
            style={[styles.actionCard, {
              backgroundColor: enDemostracion ? 'rgba(224,135,0,0.10)' : colors.card,
              borderColor: enDemostracion ? '#E08700' : colors.border,
              borderWidth: 1,
            }]}
            onPress={async () => {
              const s = useAppStore.getState();
              if (s.qaMockRide) {
                s.setQaMockRide(false);
                return;
              }

              // ⚠️ CON UN VIAJE DE VERDAD EN CURSO, NO.
              // Encenderlo a mitad de un viaje real dejaría a la persona
              // mirando un mapa donde no sabe cuál de los dos choferes es el
              // que viene. `rideSessionStore` es quien sabe si hay un viaje
              // vivo, porque lo guarda en disco y sobrevive a que Android mate
              // la app.
              try {
                const sesion = await rideSessionStore.read();
                if (sesion.activeRideId) {
                  Alert.alert(
                    'Ahora no',
                    'Tienes un viaje en curso. Cuando termine podrás ver la demostración.'
                  );
                  return;
                }
              } catch {
                // Si no se puede leer, se sigue: el cintillo y el apagado
                // automático siguen protegiendo.
              }

              s.setQaMockRide(true);
              Alert.alert(
                'Modo demostración encendido',
                'Pide un viaje y verás el recorrido completo con un chofer de mentira: cómo llega, cómo empieza y cómo termina.\n\nNo viene nadie a buscarte, y no se cobra nada. Se apaga solo al terminar.'
              );
            }}
          >
            <View style={[styles.actionIconContainer, { backgroundColor: enDemostracion ? 'rgba(224,135,0,0.15)' : 'rgba(142,68,173,0.12)' }]}>
              <Ionicons name="flask-outline" size={24} color={enDemostracion ? '#E08700' : '#8E44AD'} />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>
                {enDemostracion ? 'Modo demostración encendido' : 'Ver cómo funciona un viaje'}
              </Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                {enDemostracion
                  ? 'Toca para apagarlo y volver a los viajes reales'
                  : 'Un viaje de ejemplo con un chofer de mentira, sin esperar a que haya alguien cerca'}
              </Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color={enDemostracion ? '#E08700' : '#8E44AD'} />
          </TouchableOpacity>
          )}

          {/* ────────────────────────────────────────────────────────────────
              MODO QA — Pruebas internas (SOLO visible en builds de desarrollo).
              Gate por `__DEV__`: en cualquier APK release (incluyendo nuestros
              builds locales con `gradlew assembleRelease`), `__DEV__` es false
              y este bloque entero NO se renderiza. En `expo start` / dev client
              es true y aparece para pruebas internas.
              ──────────────────────────────────────────────────────────── */}
          {__DEV__ && (
          <>
          <Text style={[styles.sectionTitle, { color: '#8E44AD', marginTop: 30 }]}>🧪 MODO QA — PRUEBAS INTERNAS</Text>

          <TouchableOpacity
            style={[styles.actionCard, { backgroundColor: 'rgba(142, 68, 173, 0.08)', borderColor: '#8E44AD', borderWidth: 1, marginTop: 8 }]}
            onPress={() => {
              const s = useAppStore.getState();
              const next = !(s.isVerified && s.isDriverVerified);
              s.setVerified(next);
              s.setDriverVerified(next);
              Alert.alert(
                next ? '✅ Cuenta marcada como verificada' : '↩️ Estado real restaurado',
                next
                  ? 'Ahora puedes acceder a pantallas de chofer/repartidor sin completar KYC. Útil solo para probar — desactívalo antes de uso real.'
                  : 'Restauramos tu estado real. Tendrás que completar KYC para acceder a vistas restringidas.'
              );
            }}
          >
            <View style={[styles.actionIconContainer, { backgroundColor: 'rgba(142, 68, 173, 0.15)' }]}>
              <Ionicons name={isVerified ? 'checkmark-circle' : 'flash-outline'} size={24} color="#8E44AD" />
            </View>
            <View style={styles.actionTextContainer}>
              <Text style={[styles.actionTitle, { color: colors.text }]}>
                {isVerified ? 'Verificación QA activa' : 'Bypass KYC (Modo QA)'}
              </Text>
              <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                {isVerified ? 'Toca para desactivar y volver al estado real' : 'Saltar verificación para probar todas las pantallas'}
              </Text>
            </View>
            <Ionicons name="chevron-forward" size={20} color="#8E44AD" />
          </TouchableOpacity>

          <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, marginTop: 12 }}>
            {[
              { label: '🚖 Pasajero', value: 'PASSENGER' as const },
              { label: '🚗 Chofer', value: 'DRIVER' as const },
              { label: '🛵 Repartidor', value: 'DELIVERY_DRIVER' as const },
              { label: '🍔 Cliente Comida', value: 'FOOD_DELIVERY' as const },
              { label: '🚙 Owner Rent Car', value: 'RENT_CAR_OWNER' as const },
              { label: '🍽️ Owner Restaurante', value: 'RESTAURANT_OWNER' as const },
            ].map((r) => {
              const isActive = role === r.value;
              return (
                <TouchableOpacity
                  key={r.value}
                  onPress={() => {
                    const s = useAppStore.getState();
                    s.setRole(r.value);
                    s.setBaseRole(r.value);
                    // Para roles operativos, marcar verificación automáticamente
                    // para evitar fricción al alternar roles en QA.
                    if (r.value === 'DRIVER' || r.value === 'DELIVERY_DRIVER') {
                      s.setDriverVerified(true);
                    }
                    s.setVerified(true);
                    // Llevar al usuario al landing del rol elegido para validar UX completa
                    if (r.value === 'RENT_CAR_OWNER') {
                      router.replace('/(tabs)/dashboard');
                    } else if (r.value === 'FOOD_DELIVERY') {
                      router.replace('/(tabs)/food');
                    } else {
                      router.replace('/(tabs)/map');
                    }
                  }}
                  style={{
                    paddingHorizontal: 14,
                    paddingVertical: 8,
                    borderRadius: 20,
                    backgroundColor: isActive ? '#8E44AD' : 'rgba(142, 68, 173, 0.08)',
                    borderWidth: 1,
                    borderColor: '#8E44AD',
                  }}
                >
                  <Text style={{ color: isActive ? '#FFF' : '#8E44AD', fontWeight: '700', fontSize: 13 }}>
                    {r.label}
                  </Text>
                </TouchableOpacity>
              );
            })}
          </View>
          </>
          )}

          {/* ZONA DE PELIGRO — en vista previa no hay cuenta que borrar, así que
              el bloque entero se oculta en vez de ofrecer un botón que no puede
              hacer nada. */}
          {!esInvitado() && (
            <>
              <Text style={[styles.sectionTitle, { color: '#FF3B30', marginTop: 30 }]}>ZONA DE PELIGRO</Text>

              <TouchableOpacity style={[styles.actionCard, { backgroundColor: 'rgba(255, 59, 48, 0.05)', borderColor: '#FF3B30', borderWidth: 1 }]} onPress={abrirBorrarCuenta}>
                <View style={[styles.actionIconContainer, {backgroundColor: 'rgba(255, 59, 48, 0.1)'}]}>
                  <Ionicons name="trash-outline" size={24} color="#FF3B30" />
                </View>
                <View style={styles.actionTextContainer}>
                  <Text style={[styles.actionTitle, { color: '#FF3B30' }]}>Eliminar Mi Cuenta</Text>
                  {/* Decía "Borrado inmediato". Arranca al confirmar, pero
                      puede tardar minutos: el modal ya lo advierte y este
                      subtítulo no debe contradecirlo. */}
                  <Text style={[styles.actionSubtitle, { color: colors.textSecondary }]}>
                    Se borra al confirmar, sin vuelta atrás
                  </Text>
                </View>
                <Ionicons name="chevron-forward" size={20} color="#FF3B30" />
              </TouchableOpacity>
            </>
          )}

          {/* CERRAR SESION / SALIR DE VISTA PREVIA */}
          <TouchableOpacity
            style={[styles.logoutBtn, { backgroundColor: colors.card }, saliendo && { opacity: 0.6 }]}
            onPress={handleLogout}
            disabled={saliendo}
          >
            {saliendo ? (
              <ActivityIndicator size="small" color="#FF3B30" />
            ) : (
              <Ionicons name={esInvitado() ? 'exit-outline' : 'log-out-outline'} size={24} color="#FF3B30" />
            )}
            <Text style={styles.logoutText}>
              {saliendo
                ? 'Cerrando sesión…'
                : esInvitado() ? 'Salir de la vista previa' : 'Cerrar Sesión'}
            </Text>
          </TouchableOpacity>

        </ScrollView>
      </SafeAreaView>

      {/* ───────────────────────────────────────────────────────────────────
          BORRADO DE CUENTA — confirmación escrita.
          Va en un Modal propio y no en Alert.alert porque (a) en web
          Alert.alert de React Native no pinta nada y (b) `Alert.prompt`, que es
          la única variante con campo de texto, solo existe en iOS: en Android
          —la plataforma que va a Google Play— no habría dónde escribir.
          ─────────────────────────────────────────────────────────────────── */}
      {/* onRequestClose es el botón ATRÁS de Android. Si el usuario lo pulsa a
          mitad del borrado, el modal se cerraba y se quedaba sin saber si su
          cuenta se borró o no —mientras el servidor seguía borrando—. Mientras
          `borrando` esté activo el atrás no cierra nada. */}
      <Modal
        visible={borrarVisible}
        transparent
        animationType="fade"
        onRequestClose={() => { if (!borrando) cerrarModalBorrado(); }}
      >
        <View style={styles.borrarOverlay}>
          <View style={[styles.borrarCaja, { backgroundColor: colors.card, borderColor: '#FF3B30' }]}>
            <ScrollView showsVerticalScrollIndicator={false}>
              {borradoHecho ? (
                <>
                  {/* DOS ACUSES DISTINTOS, PORQUE SON DOS RESULTADOS DISTINTOS.
                      El servidor devuelve `pendientes` con lo que no pudo
                      terminar. Antes esta pantalla lo ignoraba y siempre decía
                      "tus fotos y tus documentos fueron eliminados": con un
                      borrado parcial, eso es una afirmación falsa sobre datos
                      personales, y el usuario se iba creyendo que su cédula ya
                      no estaba en ningún sitio. */}
                  {pendientesBorrado.length > 0 ? (
                    <>
                      <Text style={[styles.borrarTitulo, { color: '#FF9500' }]}>
                        Cuenta eliminada, pero quedó algo pendiente
                      </Text>
                      <Text style={[styles.borrarTexto, { color: colors.text, fontWeight: '700' }]}>
                        Tu acceso a Go Safely está eliminado: ya no puedes iniciar sesión con
                        esta cuenta. Pero no pudimos terminar de borrar todo. Esto es lo que
                        quedó:
                      </Text>
                      <View style={styles.borrarAviso}>
                        {pendientesBorrado.map((p, i) => (
                          <Text
                            key={i}
                            style={[styles.borrarTexto, { color: '#FF9500', marginTop: i === 0 ? 0 : 6 }]}
                          >
                            • {p}
                          </Text>
                        ))}
                      </View>
                      <Text style={[styles.borrarTexto, { color: colors.textSecondary }]}>
                        No lo dejamos así: escríbenos por WhatsApp con el botón de abajo y lo
                        terminamos nosotros a mano. Del resto —tu perfil, tus fotos y tus
                        documentos— sí se borró todo, y se conservan, como te advertimos, los
                        registros contables y los viajes y pedidos ya terminados sin tu nombre
                        ni tu teléfono, más la foto de los comprobantes de depósito que hayas
                        subido.
                      </Text>
                      {!!avisoWhatsapp && (
                        <Text style={[styles.borrarTexto, { color: '#FF3B30' }]}>{avisoWhatsapp}</Text>
                      )}
                    </>
                  ) : (
                    <>
                      <Text style={[styles.borrarTitulo, { color: colors.text }]}>Cuenta eliminada</Text>
                      {/* El acuse repite lo que se conserva. Decir solo "tus datos
                          personales fueron eliminados" daría a entender que no
                          quedó absolutamente nada, y la foto del comprobante de
                          depósito SÍ queda (ver el texto de arriba). Un acuse que
                          contradice la advertencia es el mismo fallo que estamos
                          arreglando, solo que al final del flujo. */}
                      <Text style={[styles.borrarTexto, { color: colors.textSecondary }]}>
                        Tu perfil, tus fotos, tus documentos y tu acceso a Go Safely fueron
                        eliminados. Ya no puedes iniciar sesión con esta cuenta. Como te
                        advertimos antes de confirmar, se conservan los registros contables y
                        los viajes y pedidos ya terminados —sin tu nombre ni tu teléfono— y la
                        foto de los comprobantes de depósito que hayas subido. Si quieres
                        volver a usar la app, tendrás que registrarte de nuevo desde cero.
                      </Text>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Text style={[styles.borrarTitulo, { color: '#FF3B30' }]}>Eliminar mi cuenta</Text>

                  {/* El borrado arranca al confirmar, pero NO es instantáneo:
                      la función recorre viajes, pedidos, asientos contables y
                      seis carpetas de fotos. Decir solo "al momento" y luego
                      dejar al usuario mirando una ruedita varios minutos se
                      lee como que se colgó. Se avisa antes. */}
                  <Text style={[styles.borrarTexto, { color: colors.text, fontWeight: '700' }]}>
                    Esto arranca AL MOMENTO en que confirmes, no en 30 días, y no se puede
                    deshacer. Si tienes mucho historial puede tardar unos minutos: deja la
                    app abierta hasta que te avisemos que terminó.
                  </Text>

                  {cargandoPrevia && (
                    <View style={{ flexDirection: 'row', alignItems: 'center', marginTop: 12 }}>
                      <ActivityIndicator color="#FF3B30" />
                      <Text style={[styles.borrarTexto, { color: colors.textSecondary, marginLeft: 10, marginTop: 0 }]}>
                        Revisando tu cuenta…
                      </Text>
                    </View>
                  )}

                  {!!previaError && (
                    <Text style={[styles.borrarTexto, { color: '#FF9500' }]}>{previaError}</Text>
                  )}

                  {/* Motivo REAL por el que no se puede borrar ahora, en vez de
                      un botón que falla sin explicar nada. */}
                  {!!previaBorrado && previaBorrado.bloqueos.length > 0 && (
                    <View style={styles.borrarAviso}>
                      {previaBorrado.bloqueos.map((b, i) => (
                        <Text key={i} style={[styles.borrarTexto, { color: '#FF3B30', marginTop: i === 0 ? 0 : 6 }]}>
                          • {b}
                        </Text>
                      ))}
                    </View>
                  )}

                  <Text style={[styles.borrarSubtitulo, { color: colors.text }]}>Se borra para siempre</Text>
                  <Text style={[styles.borrarTexto, { color: colors.textSecondary }]}>
                    Tu perfil, tu foto, tu teléfono y tu correo · tus direcciones guardadas ·
                    tus notificaciones · tu ficha de chofer, tu ubicación en vivo y tu
                    historial de recorridos · tus documentos de identidad (cédula, licencia,
                    selfie, papel de buena conducta) · las fotos que enviaste en el chat de un
                    viaje · tu ficha de candidato y los documentos que subiste al postularte a
                    un Rent Car · tus vehículos, tu restaurante y su menú · los datos de tus
                    hijos y tu ruta escolar · tu ficha de cliente en Stripe · tu acceso a Go
                    Safely.
                  </Text>

                  {/* ESTE BLOQUE PROMETÍA DE MÁS. Antes cerraba con "queda el
                      monto y la fecha, sin identificarte", y eso NO es lo que
                      hace el servidor: `functions/src/cuenta.ts` conserva TAL
                      CUAL los comprobantes de depósito en Storage
                      (/recharge_receipts, /ad_receipts) —la propia regla de
                      Storage prohíbe borrarlos— y esa foto es la del papel del
                      banco, que suele traer el nombre impreso. También conserva
                      a propósito el uid en /subscription_payments (forma parte
                      del id del documento) y en /driver_bonuses.
                      El revisor de Google compara esta pantalla contra lo que
                      la app hace: si el texto dice "sin identificarte" y queda
                      una foto con el nombre, la app miente. Ahora se separa en
                      dos bloques y se dice la verdad completa. */}
                  <Text style={[styles.borrarSubtitulo, { color: colors.text }]}>
                    Se conserva sin tu nombre ni tu teléfono
                  </Text>
                  <Text style={[styles.borrarTexto, { color: colors.textSecondary }]}>
                    Los viajes y pedidos ya terminados, y los registros de pagos de
                    cuotas (también los hechos con tarjeta), bonos y recargas. No son solo tuyos: son el comprobante del
                    cobro de la otra persona y el respaldo contable que el negocio está
                    obligado a poder sustentar ante Impuestos Internos. De ellos quitamos tu
                    nombre, tu teléfono, tus fotos, tus cuentas bancarias y la dirección de
                    entrega; quedan el monto, la fecha y un código interno. También queda, sin
                    tu nombre, cualquier alerta de pánico que hayas enviado —es la constancia
                    de un incidente de seguridad— y las calificaciones que escribiste, que
                    siguen contando para la reputación de quien las recibió pero dejan de
                    estar atadas a ti. Si usaste el viaje gratis de bienvenida, también
                    conservamos una huella (un código calculado a partir del dato, que no lo
                    contiene escrito) de tu teléfono, de tu correo verificado y, si al aprobar
                    tu verificación registramos el número de tu cédula, de tu cédula. Queda
                    sin tu cuenta ni tu viaje, pero quien ya conozca tu número puede comprobar
                    si coincide. Tiene un solo fin: que el viaje gratis de bienvenida no se
                    repita con otra cuenta.
                  </Text>

                  <Text style={[styles.borrarSubtitulo, { color: '#FF9500' }]}>
                    Se conserva TAL CUAL: la foto de tus comprobantes de depósito
                  </Text>
                  <Text style={[styles.borrarTexto, { color: colors.textSecondary }]}>
                    Si alguna vez recargaste tu billetera o pagaste por depósito o
                    transferencia, la FOTO del comprobante que subiste no se borra, y esa
                    imagen normalmente trae impreso tu nombre o un número de cuenta. Es la
                    única evidencia de que ese dinero entró: sin ella el ingreso no se puede
                    sustentar ante Impuestos Internos, y por eso hay obligación de guardarla.
                    Esto, la huella de arriba y el registro de tus cobros con tarjeta que
                    Stripe conserva por obligación legal es lo único con datos tuyos que queda
                    después del borrado, y preferimos decírtelo antes de que confirmes y no
                    después.
                  </Text>

                  {!!previaBorrado && previaBorrado.saldoQueSePierde > 0 && (
                    <View style={styles.borrarAviso}>
                      <Text style={[styles.borrarTexto, { color: '#FF3B30', marginTop: 0, fontWeight: '700' }]}>
                        Perderás {pesos(previaBorrado.saldoQueSePierde)} de tu
                        billetera. No se devuelven. Úsalos antes si no quieres perderlos.
                      </Text>
                    </View>
                  )}

                  {!!previaBorrado && previaBorrado.multaPendiente > 0 && (
                    /* 3-oct-2026: esto decía que la multa quedaba «anotada en el
                       registro del borrado» y nada más, con un comentario que
                       aclaraba que NO se cobraba después. Eso era cierto
                       entonces y es FALSO ahora: `dejarSancionEnElRegistro`
                       (functions/src/loyalty.ts) la guarda en las llaves de
                       identidad de la persona, y `heredarSancionesPendientes`
                       la suma a la cuenta nueva en cuanto entra.
                       Cobrarle a alguien algo que la pantalla le dijo que no
                       se le iba a cobrar no es un detalle: es mentirle. */
                    <Text style={[styles.borrarTexto, { color: '#FF9500' }]}>
                      Tienes una multa pendiente de {pesos(previaBorrado.multaPendiente)}.
                      Eliminar la cuenta no la salda y <Text style={{ fontWeight: '700' }}>no la
                      borra</Text>: si vuelves a Go Safely con otra cuenta, la multa te
                      sigue. Lo mismo con el bloqueo por cancelaciones, si lo tienes.
                    </Text>
                  )}

                  <Text style={[styles.borrarSubtitulo, { color: colors.text }]}>
                    Para confirmar, escribe {FRASE_BORRADO}
                  </Text>
                  <TextInput
                    value={textoBorrado}
                    onChangeText={setTextoBorrado}
                    autoCapitalize="characters"
                    autoCorrect={false}
                    editable={!borrando}
                    // Sin placeholder con la palabra dentro: si el marcador dice
                    // "ELIMINAR", el usuario lo lee como si ya estuviera escrito.
                    placeholder="Escribe aquí la palabra"
                    placeholderTextColor={colors.textSecondary}
                    style={[styles.borrarInput, { color: colors.text, borderColor: colors.border, backgroundColor: colors.background }]}
                  />

                  {/* Mientras el servidor borra, el único indicio era una
                      ruedita dentro del botón. Con un borrado que puede durar
                      minutos eso se lee como "se colgó" y el usuario mata la
                      app a mitad. Aquí se le dice qué está pasando. */}
                  {borrando && (
                    <Text style={[styles.borrarTexto, { color: colors.text, fontWeight: '700' }]}>
                      Borrando tu cuenta… Esto puede tardar unos minutos. No cierres la app.
                    </Text>
                  )}

                  {!!errorBorrado && (
                    <Text style={[styles.borrarTexto, { color: '#FF3B30' }]}>{errorBorrado}</Text>
                  )}
                </>
              )}
            </ScrollView>

            <View style={styles.borrarBotones}>
              {borradoHecho ? (
                <>
                  {/* Un pendiente sin salida es un callejón sin salida: si algo
                      quedó sin borrar, el botón para reclamarlo tiene que estar
                      aquí mismo. Al cerrar el modal se limpia la sesión y esta
                      pantalla desaparece, así que después ya no habría dónde
                      pulsarlo. El número sale de constants/contacto.ts. */}
                  {pendientesBorrado.length > 0 && (
                    <TouchableOpacity
                      style={[styles.borrarBoton, { backgroundColor: '#25D366' }]}
                      onPress={() => {
                        Linking.openURL(
                          whatsappSoporte(
                            'Eliminé mi cuenta de Go Safely y la app me avisó de que quedaron ' +
                              'datos sin borrar. ¿Pueden terminarlo?'
                          )
                        ).catch(() => {
                          // Sin WhatsApp instalado el botón no puede quedarse
                          // mudo: aquí ya no hay Alert que valga (en web
                          // Alert.alert de React Native no pinta nada), así que
                          // el número y el correo se enseñan en el propio modal.
                          setAvisoWhatsapp(
                            `No pudimos abrir WhatsApp. Escríbenos al ${SOPORTE_TELEFONO} o al correo ${SOPORTE_CORREO}.`
                          );
                        });
                      }}
                    >
                      <Text style={styles.borrarBotonTexto}>Escribir por WhatsApp</Text>
                    </TouchableOpacity>
                  )}
                  <TouchableOpacity
                    style={[styles.borrarBoton, { backgroundColor: '#FF3B30' }]}
                    onPress={cerrarModalBorrado}
                  >
                    <Text style={styles.borrarBotonTexto}>Entendido</Text>
                  </TouchableOpacity>
                </>
              ) : (
                <>
                  <TouchableOpacity
                    style={[styles.borrarBoton, { backgroundColor: colors.border }]}
                    onPress={cerrarModalBorrado}
                    disabled={borrando}
                  >
                    <Text style={[styles.borrarBotonTexto, { color: colors.text }]}>Cancelar</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    style={[
                      styles.borrarBoton,
                      { backgroundColor: puedeConfirmarBorrado ? '#FF3B30' : 'rgba(255,59,48,0.35)' },
                    ]}
                    onPress={confirmarBorrarCuenta}
                    disabled={!puedeConfirmarBorrado}
                  >
                    {borrando ? (
                      <ActivityIndicator color="#FFF" />
                    ) : (
                      <Text style={styles.borrarBotonTexto}>Eliminar definitivamente</Text>
                    )}
                  </TouchableOpacity>
                </>
              )}
            </View>
          </View>
        </View>
      </Modal>

      <WalletModal visible={walletVisible} onClose={() => setWalletVisible(false)} />
      {/* ⚠️ AQUI DECIA `vehicleType="CAR"` ESCRITO A MANO.
          Con eso, a TODO chofer se le prometian RD$1.000 de bono por cada 3
          referidos — tambien a los de moto y bici, a los que el servidor les
          paga 800. Leian la promesa, invitaban a tres, y les entraban 200 pesos
          menos sin ninguna explicacion.
          `useVehiculoDelChofer` resuelve el de verdad: primero el que aprobo
          una persona en el KYC, y si no, el que el chofer declaro. */}
      <RewardsModal
        visible={rewardsVisible}
        onClose={() => setRewardsVisible(false)}
        vehicleType={vehiculoDelChofer}
      />
    </ScreenBackground>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
  container: {
    padding: SIZES.padding,
    paddingTop: 40,
    paddingBottom: 140,
  },
  pageTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  profileCard: {
    borderRadius: 20,
    padding: 20,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 30,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 10,
    elevation: 2,
  },
  avatarContainer: {
    width: 70,
    height: 70,
    borderRadius: 35,
    backgroundColor: '#0A2540', 
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
    position: 'relative',
  },
  verifiedBadge: {
    position: 'absolute',
    bottom: -2,
    right: -2,
    backgroundColor: '#FFF',
    borderRadius: 12,
    padding: 1,
  },
  profileInfo: {
    flex: 1,
    alignItems: 'flex-start',
  },
  profileName: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  profilePhone: {
    fontSize: 14,
    marginBottom: 8,
  },
  roleBadge: {
    backgroundColor: 'rgba(76, 175, 80, 0.1)', 
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 6,
  },
  roleBadgeText: {
    color: '#4CAF50',
    fontSize: 12,
    fontWeight: 'bold',
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 12,
    marginLeft: 4,
    marginTop: 10,
  },
  actionCard: {
    borderRadius: 16,
    padding: 16,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 10,
    elevation: 2,
  },
  actionIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 16,
  },
  actionTextContainer: {
    flex: 1,
  },
  actionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 4,
  },
  actionSubtitle: {
    fontSize: 13,
  },
  logoutBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 16,
    padding: 18,
    marginTop: 20,
    marginBottom: 40,
    shadowColor: '#FF3B30',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 10,
    elevation: 2,
    borderWidth: 1,
    borderColor: 'rgba(255, 59, 48, 0.2)',
  },
  logoutText: {
    color: '#FF3B30',
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 10,
  },
  avatarImage: {
    width: 70,
    height: 70,
    borderRadius: 35,
    resizeMode: 'cover',
  },

  // ── Modal de borrado de cuenta ──────────────────────────────────────────
  borrarOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.65)',
    justifyContent: 'center',
    padding: 20,
  },
  borrarCaja: {
    borderRadius: 18,
    borderWidth: 1,
    padding: 20,
    // Tope de alto para que el botón de Cancelar no quede fuera de pantalla en
    // teléfonos chicos: el texto es largo a propósito y se desplaza dentro.
    maxHeight: '85%',
  },
  borrarTitulo: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  borrarSubtitulo: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 16,
  },
  borrarTexto: {
    fontSize: 13,
    lineHeight: 19,
    marginTop: 8,
  },
  borrarAviso: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#FF3B30',
    backgroundColor: 'rgba(255, 59, 48, 0.08)',
    padding: 12,
    marginTop: 14,
  },
  borrarInput: {
    borderWidth: 1,
    borderRadius: 10,
    paddingHorizontal: 14,
    paddingVertical: 12,
    marginTop: 10,
    fontSize: 16,
    fontWeight: '700',
    letterSpacing: 1,
  },
  borrarBotones: {
    flexDirection: 'row',
    gap: 10,
    marginTop: 18,
  },
  borrarBoton: {
    flex: 1,
    borderRadius: 12,
    paddingVertical: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
  borrarBotonTexto: {
    color: '#FFF',
    fontSize: 15,
    fontWeight: 'bold',
  },
});
